import { Injectable } from '@angular/core';

declare let THREE: any;
import { FloorObjectHandler } from './Handlers/FloorObjectHandler';
import { BaseHandler } from './Handlers/BaseHandler';
import { SceneUtilsService } from '../../../services/scene-utils.service';
import { StageService } from '../../../services/stage.service';
import { TouchAndMouseMap } from '../../touch-and-mouse-map';
import { Model3DService } from '../../../services/model3-d.service';
import { GhostObjectService } from '../../../services/ghost-object.service';
import { EventLogService, Actions } from './../../../services/eventLog';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { ConstantsService } from '../../../services/constants.service';
import { RemoveWindowsDoorsService } from '../../../services/remove-windows-doors.service';
import { WallMountableObjectHandler } from './Handlers/wallHandlers.ts/WallMountableObjectHandler';
import { WallEmbeddableObjectHandler } from './Handlers/wallHandlers.ts/WallEmbeddableObjectHandler';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ObjectAddService extends TouchAndMouseMap {
  private _raycastObjects: any;
  protected _handlers: BaseHandler[];
  protected _activeEntity: any;
  protected _raycaster: any;
  protected _currentHandler: BaseHandler | null;
  protected _ghostObject: any;

  constructor(
    private ghostObjectService: GhostObjectService,
    protected floorObjectHandler: FloorObjectHandler,
    protected wallEmbeddableObjectHandler: WallEmbeddableObjectHandler,
    protected wallMountableObjectHandler: WallMountableObjectHandler,
    private sceneUtils: SceneUtilsService,
    protected StageSrvc: StageService,
    protected model3D: Model3DService,
    private eventLogSrvc: EventLogService,
    private loadingSpinnerService: LoadingSpinnerService,
    private constantsService: ConstantsService,
    private removeWindowsDoorsService: RemoveWindowsDoorsService
  ) {
    super();
    this._handlers = [floorObjectHandler, wallEmbeddableObjectHandler, wallMountableObjectHandler];
    this._activeEntity = null;
    this._raycaster = new THREE.Raycaster();
    this._currentHandler = null;
    this._ghostObject = this.ghostObjectService.buildGhostObject();
    this._ghostObject.visible = false;
  }

  setEntity(entity) {
    this._activeEntity = entity;
  }

  /**
   * Тач: нельзя вызывать `hold()` на touchstart (как в базовом TouchAndMouseMap) — сначала нужны
   * логика mouseEnter + move по стене и отпускание (touchEnd → release → hold).
   * Возвращаем false, чтобы Select3d не воспринимал этот палец как начало тапа.
   */
  touchStart(e: TouchEvent) {
    if (!this.isEnabled() || !this._activeEntity) {
      return;
    }
    this.beginTouchFromCanvas(e);
    this.mouseEnter();
    this.move(e as any);
    return false;
  }

  release(e?: MouseEvent) {
    const placing = !!this._activeEntity || (this._ghostObject && this._ghostObject.visible);
    if (placing) {
      return this.hold();
    }
  }

  hold() {
    let result = true;
    const ghostObject = this._ghostObject;

    if (ghostObject.visible) {
      ghostObject.visible = false;
      result = false;

      const wallName = ghostObject.userData.wall;
      const currentHandler = this._currentHandler;
      this.loadingSpinnerService.spinnerLoadingListAdd('ObjectAddService');
      this.model3D
        .create(this._activeEntity, {
          position: ghostObject.position,
          rotation: ghostObject.rotation,
          wall: wallName,
          show3DObject: true
        })
        .then(obj => {
          const { parent, boundingBox, entity } = ghostObject.userData;
          obj.userData.boundingBox = boundingBox;
          obj.name = entity.productType;

          const objSize = new THREE.Box3().setFromObject(obj).getSize(new THREE.Vector3());

          // console.log('objSize', objSize);

          this.eventLogSrvc.dispatch(new Actions.AddObjectAction(obj));

          if (parent) {
            THREE.SceneUtils.attach(obj, this.StageSrvc.getScene(), parent);
            this.StageSrvc.objectAdded.next(obj);
          }

          currentHandler.dragEnd(obj);

          delete ghostObject.userData.entity;
          delete ghostObject.userData.parent;
          this.loadingSpinnerService.spinnerLoadingListRemove('ObjectAddService');
        });
    }

    this._currentHandler = null;
    this._raycastObjects = null;
    this._activeEntity = null;
    return result;
  }

  mouseEnter() {
    this.StageSrvc.add(this._ghostObject);
    const entity = this._activeEntity;
    if (entity) {
      // console.log('entity', entity);
      this._currentHandler = this._handlers.find(handler => handler.canExecute(entity));
      if (this._currentHandler) {
        this._raycastObjects = this._currentHandler.getRaycastObjects();
        this._currentHandler.setGhostObject(this._ghostObject);
      }
      this._ghostObject.scale.set(entity.length, entity.height, entity.width);
      this._ghostObject.userData.entity = entity;
    }
  }

  move(e) {
    if (this._activeEntity && this._currentHandler) {
      this.sceneUtils.getRay(e.offsetX, e.offsetY, this._raycaster);

      const intersection = this._raycaster.intersectObjects(this._raycastObjects, true);

      if (intersection.length === 0 || !this._raycastObjects.includes(intersection[0].object)) {
        return;
      }

      const handled = this._currentHandler.dragBegin(intersection);

      if (handled) {
        this._ghostObject.visible = true;
        // this.ghostObject.position.y = 500;
        return false;
      }
    }
  }

  disable() {
    TouchAndMouseMap.prototype.disable.call(this);
    this._ghostObject.visible = false;
    this._activeEntity = null;
    this._raycastObjects = null;
    super.disable();
  }

  dispose() {
    TouchAndMouseMap.prototype.dispose.call(this);
    this.StageSrvc.remove(this._ghostObject);
  }

  remove() {
    this.removeWindowsDoorsService.drawSprites();
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectAdd/object-add.service.ts